import { BrowserModule } from '@angular/platform-browser';
import { SelectDropDownModule } from 'ngx-select-dropdown'
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgModule } from '@angular/core';
import {MatSelectModule} from '@angular/material/select';
// import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { MatInputModule } from '@angular/material/input';
import { LoginComponent } from './components/login/login.component';
import { AsyncPipe, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { HttpClientModule  } from '@angular/common/http';
import { CmtopmsbookingComponent } from './components/cmtopmsbooking/cmtopmsbooking.component';
import { MatAutocompleteModule, MatCheckboxModule, MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import {MatSortModule} from '@angular/material/sort';
import {MatProgressBarModule} from '@angular/material/progress-bar'
import {MatTableModule} from '@angular/material/table';
import { BookinglogComponent } from './components/bookinglog/bookinglog.component';
import { InventorylogComponent } from './components/inventorylog/inventorylog.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
//import { beautify } from 'xml-beautifier';
//import {MatPaginator, MatTableDataSource} from '@angular/material';
import {MatRadioModule} from '@angular/material/radio';

import {
  MatButtonModule,
  MatFormFieldModule,
  MatIconModule,
  MatListModule,
  MatSidenavModule,
  MatCardModule
} from "@angular/material";
import { StrlogComponent } from './components/strlog/strlog.component';
import { BtealogComponent } from './components/btealog/btealog.component';
import { FxcrsinventoryComponent } from './components/fxcrsinventory/fxcrsinventory.component';
import { FxcrsdownloadComponent } from './components/fxcrsdownload/fxcrsdownload.component';
import { FxcrsuploadComponent } from './components/fxcrsupload/fxcrsupload.component';
import { EdwComponent } from './components/edw/edw.component';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
// import { CompatibilityModule, NoConflictStyleCompatibilityMode } from 'md2';
import { OTAInsightsComponent } from './components/ota-insights/ota-insights.component';
import { RestrictionsEnhancedComponent } from './components/restrictions-enhanced/restrictions-enhanced.component';
import { SharedPipe } from './components/shared.pipe';
import { RateSyncFortuneComponent } from './components/rate-sync-fortune/rate-sync-fortune.component';
import { RateSyncToChannelComponent } from './components/rate-sync-to-channel/rate-sync-to-channel.component';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { BWPOSComponent } from './components/bwpos/bwpos.component';
import { BWCRMComponent } from './components/bwcrm/bwcrm.component';
import { QatarUploadComponent } from './components/qatar-upload/qatar-upload.component';
import { GEMKOTDownloadComponent } from './components/gemkot-download/gemkot-download.component';
import { RatepingUploadComponent } from './components/rateping-upload/rateping-upload.component';
import { HotelTwoexeComponent } from './components/general/hotel-twoexe/hotel-twoexe.component';
import { HotelOfflineComponent } from './components/general/hotel-offline/hotel-offline.component';
import { HotelMultipleCmcrsComponent } from './components/general/hotel-multiple-cmcrs/hotel-multiple-cmcrs.component';
import { GeneralcrmComponent } from './components/generalcrm/generalcrm.component';
import { FxservicelogComponent } from './components/fxservicelog/fxservicelog.component';
import { PulzelogComponent } from './components/pulzelog/pulzelog.component';
import { RevnomixComponent } from './components/revnomix/revnomix.component';
import { FxEInvoiceComponent } from './components/fx-e-invoice/fx-e-invoice.component';
import { BytDisplayComponent } from './components/byt-display/byt-display.component';
import { BbrDisplayComponent } from './components/bbr-display/bbr-display.component';
import { FxgemUploadlogComponent } from './components/fxgem-uploadlog/fxgem-uploadlog.component';
import { FxgemEmaillogComponent } from './components/fxgem-emaillog/fxgem-emaillog.component';
import { FxgemPoslogComponent } from './components/fxgem-poslog/fxgem-poslog.component';
import { FxgemPosapplogComponent } from './components/fxgem-posapplog/fxgem-posapplog.component';
import { ViewhotelsbycmComponent } from './components/general/viewhotelsbycm/viewhotelsbycm.component';
import { FxgemDoclogComponent } from './components/fxgem-doclog/fxgem-doclog.component';
import { FxgemSettlementlogComponent } from './components/fxgem-settlementlog/fxgem-settlementlog.component';
import { GuestprofileLogComponent } from './components/guestprofile-log/guestprofile-log.component';
import { CompanyprofileLogComponent } from './components/companyprofile-log/companyprofile-log.component';
import { GuestvisitrevenuesyncComponent } from './components/guestvisitrevenuesync/guestvisitrevenuesync.component';
import { PosFromCrmdbComponent } from './components/itccrm/pos-from-crmdb/pos-from-crmdb.component';
import { FomFromCrmdbComponent } from './components/itccrm/fom-from-crmdb/fom-from-crmdb.component';
import { BillwisePmsdataComponent } from './components/cpo/billwise-pmsdata/billwise-pmsdata.component';
import { GstrCleartaxComponent } from './components/cpo/gstr-cleartax/gstr-cleartax.component';
import { InvTransactionComponent } from './components/cpo/inv-transaction/inv-transaction.component';
import { OnlinePayrolljvComponent } from './components/cpo/online-payrolljv/online-payrolljv.component';
import { OnlineSalesComponent } from './components/cpo/online-sales/online-sales.component';
import { AcrCreditlimitComponent } from './components/cpo/acr-creditlimit/acr-creditlimit.component';
import { OthersComponent } from './components/cpo/others/others.component';
import { OnepagesummaryBygrpcodeComponent } from './components/onepagesummary-bygrpcode/onepagesummary-bygrpcode.component';
import { ToBookingwhizzComponent } from './components/checkin-checkout/to-bookingwhizz/to-bookingwhizz.component';
import { ToFxcrsComponent } from './components/checkin-checkout/to-fxcrs/to-fxcrs.component';
import { GeneralcrmFxComponent } from './components/generalcrm-fx/generalcrm-fx.component';
import { TrustuLogComponent } from './components/trustu-log/trustu-log.component';
import { RedalertAuditComponent } from './components/redalert-audit/redalert-audit.component';
import { UploadLogComponent } from './components/guestprofile-log/upload-log/upload-log.component';
import { OnepageSummaryComponent } from './components/general/onepage-summary/onepage-summary.component';
import { WbhidcoComponent } from './components/wbhidco/wbhidco.component';
import { SabreinhouseLoyaltyComponent } from './components/sabreinhouse-loyalty/sabreinhouse-loyalty.component';
import { DctkpiAbudhabiComponent } from './components/dctkpi-abudhabi/dctkpi-abudhabi.component';
import { BitsilaLogComponent } from './components/bitsila-log/bitsila-log.component';
import { TookanLogComponent } from './components/tookan-log/tookan-log.component';
import { BonushubRazorpayComponent } from './components/bonushub-razorpay/bonushub-razorpay.component';
import { InvFxcrsNewpipeComponent } from './components/inv-fxcrs-newpipe/inv-fxcrs-newpipe.component';
import { RatePmsNewpipeComponent } from './components/rate-pms-newpipe/rate-pms-newpipe.component';
import { HeartbeatLogsComponent } from './components/heartbeat-logs/heartbeat-logs.component';
import { BookingFxcrstofnNewpipeComponent } from './components/booking-fxcrstofn-newpipe/booking-fxcrstofn-newpipe.component';
import { BookingFntofxcrsNewpipeComponent } from './components/booking-fntofxcrs-newpipe/booking-fntofxcrs-newpipe.component';
import { MappingDetailsComponent } from './components/fx-e-invoice/mapping-details/mapping-details.component';
import { FnDhnewpipeComponent } from './components/general/fn-dhnewpipe/fn-dhnewpipe.component';
import { PropertysyncfxSUComponent } from './components/su-integration/propertysyncfx-su/propertysyncfx-su.component';
import { RoomtypesyncfxSuComponent } from './components/su-integration/roomtypesyncfx-su/roomtypesyncfx-su.component';
import { RateplansyncfxSuComponent } from './components/su-integration/rateplansyncfx-su/rateplansyncfx-su.component';
import { InventorysyncfxSuComponent } from './components/su-integration/inventorysyncfx-su/inventorysyncfx-su.component';
import { RestrictionSyncfxSuComponent } from './components/su-integration/restriction-syncfx-su/restriction-syncfx-su.component';
import { RateSyncfxSuComponent } from './components/su-integration/rate-syncfx-su/rate-syncfx-su.component';
import { ReservationSyncfxSuComponent } from './components/su-integration/reservation-syncfx-su/reservation-syncfx-su.component';
import { OhipLogComponent } from './components/ohip-log/ohip-log/ohip-log.component';
import { NewfnconfiginfoComponent } from './components/general/newfnconfiginfo/newfnconfiginfo.component';
import { NewfndhsyncreportComponent } from './components/general/newfndhsyncreport/newfndhsyncreport.component';
import { BookingChFnNewpipeComponent } from './components/booking-ch-fn-newpipe/booking-ch-fn-newpipe.component';
import { DatalakelogComponent } from './components/datalakelog/datalakelog.component';
import { FxcrstochinvflowreportComponent } from './components/fxcrstochinvflowreport/fxcrstochinvflowreport.component';
import { TajInnerCircleComponent } from './components/taj-inner-circle/taj-inner-circle.component';
import { FntochinvflowreportComponent } from './components/fntochinvflowreport/fntochinvflowreport.component';
import { OtaInsightsnewComponent } from './components/ota-insightsnew/ota-insightsnew.component';
import { NewfnpipeactionsComponent } from './components/general/newfnpipeactions/newfnpipeactions.component';
import { QatarlogsnewComponent } from './components/qatarlogsnew/qatarlogsnew.component';
import { DhproductsummarydetailsComponent } from './components/general/dhproductsummarydetails/dhproductsummarydetails.component';
import { ListdhproductsummarydetailsComponent } from './components/general/dhproductsummarydetails/listdhproductsummarydetails/listdhproductsummarydetails.component';
import { FomFromCrmdbNewComponent } from './components/itccrm/fom-from-crmdb-new/fom-from-crmdb-new.component';
import { FomFromCrmdbNewListComponent } from './components/itccrm/fom-from-crmdb-new/fom-from-crmdb-new-list/fom-from-crmdb-new-list.component';
import { BookingsChFNPhaseIIComponent } from './components/bookings-ch-fnphase-ii/bookings-ch-fnphase-ii.component';
import { BingoForcelogComponent } from './components/bingo-forcelog/bingo-forcelog.component';
import { FxProccessLogComponent } from './components/fx-proccess-log/fx-proccess-log.component';
import { WsLogComponent } from './components/ws-log/ws-log.component';
import { NepalFnmisComponent } from './components/nepal-fnmis/nepal-fnmis.component';
import { WhatsapplogComponent } from './components/whatsapplog/whatsapplog.component';
import { BookingsChFnphaseiiNewtblComponent } from './components/bookings-ch-fnphaseii-newtbl/bookings-ch-fnphaseii-newtbl.component';
import { ChannelreservationsummaryComponent } from './components/channelreservationsummary/channelreservationsummary.component';
import { FntochinvflowreportphaseIIComponent } from './components/fntochinvflowreportphase-ii/fntochinvflowreportphase-ii.component';

const AllRoutes: Routes = [
  // { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'General CRM', component: GeneralcrmComponent },  
  { path: 'Offlinehotels', component: HotelOfflineComponent },
  { path: 'Hotelswith2EXE', component: HotelTwoexeComponent },
  { path: 'HotelswithMultipleCM/CRS', component: HotelMultipleCmcrsComponent},
  { path: 'dashboard', component: DashboardComponent },
  { path: 'DownloadfromChannelsto(FN&FX)', component: BookinglogComponent},
  { path: 'ChannelsforFN+FX', component: InventorylogComponent},
  { path: 'UploadfromFN,FXtoChannels', component: CmtopmsbookingComponent },
  { path: 'STR Analytics', component: StrlogComponent },
  { path: 'BTEA', component: BtealogComponent },
  { path: 'ToFXCRS', component: FxcrsinventoryComponent }, //fxcrsinventory
  { path: 'DownloadfromFXCRStoFN', component: FxcrsdownloadComponent }, //fxcrsdownload
  { path: 'UploadfromFNtoFXCRS', component: FxcrsuploadComponent }, // fxcrsupload
  { path: 'EDW', component: EdwComponent },
  //{ path: 'OTA Insight', component: OTAInsightsComponent }, // otainsightLog
  { path: 'OTA Insight', component: OtaInsightsnewComponent },
  //New Restriction screen
  { path: 'RestrictiondeliverytoChannels', component: RestrictionsEnhancedComponent },
  { path: 'RateDeliverytoPMS', component: RateSyncFortuneComponent }, // fxcrsrateinput
  { path: 'RateDeliverytoChannels', component: RateSyncToChannelComponent },  // RateDeliverytoChannels
  { path: 'CentralCompanyprofileDeliverytoPMS', component: UnderConstructionComponent },
  { path: 'CentralGuestprofileDeliverytoPMS', component: UnderConstructionComponent },
  { path: 'RateDownload', component: UnderConstructionComponent },
  { path: 'CRMuploadfromPMS', component: UnderConstructionComponent },
  { path: 'E-invoiceDeliveryfromPMS', component: UnderConstructionComponent },
  { path: 'GroupBlockDeliverytoChannels', component: UnderConstructionComponent },
  { path: 'BWPOSUPLOAD', component: BWPOSComponent },
  { path: 'BWCRM', component: BWCRMComponent },
  { path: 'Qatar Interface', component: QatarUploadComponent },
  { path: 'GEMKOTDownload', component: GEMKOTDownloadComponent },
  { path: 'RatePingUpload', component: RatepingUploadComponent },
  { path: 'FX Service', component:FxservicelogComponent},
  { path: 'PulzeLog', component:PulzelogComponent},
  { path: 'Revnomix', component:RevnomixComponent},
  { path: 'FX E-invoice', component:FxEInvoiceComponent}, 
  { path: 'BYT', component:BytDisplayComponent}, 
  { path: 'BBR', component:BbrDisplayComponent}, 
  { path: 'Upload Log', component:FxgemUploadlogComponent},
  { path: 'EmailLog', component:FxgemEmaillogComponent},
  { path: 'POSLog', component:FxgemPoslogComponent},
  { path: 'POSAppLog', component:FxgemPosapplogComponent},
  { path: 'HotelsbyCM', component:ViewhotelsbycmComponent},
  { path: 'DocumentLog', component:FxgemDoclogComponent},
  { path: 'SettlementLog', component:FxgemSettlementlogComponent},
  { path: 'GuestProfileLog', component:GuestprofileLogComponent},
  { path: 'CompanyProfileLog', component:CompanyprofileLogComponent},
  { path: 'GuestVisitRevenueSynctoBW&CRS', component:GuestvisitrevenuesyncComponent},
  { path: 'ITCCRMPOSLog', component:PosFromCrmdbComponent},
   { path: 'FNtoChannelInventoryFlowReportPhaseII', component:FntochinvflowreportphaseIIComponent},
  /* { path: 'ITCCRMFOMLog', component:FomFromCrmdbComponent}, */
 //Indhuja 06-08-2025 Start
  {path: 'ITCCRMFOMLog', 
  children: [
    { path: "", component: FomFromCrmdbNewComponent },
    { path: "fom-from-crmdb-new-list", component: FomFromCrmdbNewListComponent }
  ]
},
//Indhuja 06-08-2025 end
  { path: 'BillwisePMSData', component:BillwisePmsdataComponent},
  { path: 'GSTRForClearTax', component:GstrCleartaxComponent},
  { path: 'OnlinePayRollJV', component:OnlinePayrolljvComponent},
  { path: 'OnlineSales', component:OnlineSalesComponent},
  { path: 'InventoryTransaction', component:InvTransactionComponent},
  { path: 'ACRCreditLimit', component:AcrCreditlimitComponent},
  { path: 'Others', component:OthersComponent},
  { path: 'onePageSummary', component:OnepagesummaryBygrpcodeComponent},
  { path: 'To BookingWhizz', component:ToBookingwhizzComponent},
  { path: 'To FXCRS', component:ToFxcrsComponent},
  { path: 'GeneralCRMFX', component:GeneralcrmFxComponent},
  { path: 'TrustULog', component:TrustuLogComponent},
  { path: 'redAlertAudit', component:RedalertAuditComponent},
  { path: 'GuestProfileUploadLog', component:UploadLogComponent},
    { path: 'OnePageSummary', component:OnepageSummaryComponent},
    { path: 'WBHIDCOLog', component:WbhidcoComponent},
    { path: 'SabreInhouseLoyalty', component:SabreinhouseLoyaltyComponent},
    { path: 'DCTKPIAbuDhabiLog', component:DctkpiAbudhabiComponent},
    {path: 'BitsilaLog',component:BitsilaLogComponent},
    {path: 'TookanLog',component:TookanLogComponent},
    {path: 'PaymentGatewayIntegrationLog',component:BonushubRazorpayComponent},
    {path: 'ToFXCRSNewPipe',component:InvFxcrsNewpipeComponent},
    {path: 'RateDeliverytoPMSNewPipe',component:RatePmsNewpipeComponent},
    {path: 'HeartbeatLogHistory',component:HeartbeatLogsComponent},
    {path: 'DownloadfromFXCRStoFNNewPipe',component:BookingFxcrstofnNewpipeComponent},
    {path: 'UploadfromFNtoFXCRSNewPipe',component:BookingFntofxcrsNewpipeComponent},
    {path: 'MappingDetails',component:MappingDetailsComponent},
    {path: 'FNtoDHNewPipe',component:FnDhnewpipeComponent},
    {path: 'PropertySyncfromFXtoSU',component:PropertysyncfxSUComponent},
    {path: 'RatePlanSyncfromFXtoSU',component:RateplansyncfxSuComponent},
    {path: 'RoomTypeSyncfromFXtoSU',component:RoomtypesyncfxSuComponent},
    {path: 'InventorySyncfromFXtoSU',component:InventorysyncfxSuComponent},
    {path: 'RateSyncfromFXtoSU',component:RateSyncfxSuComponent},
    {path: 'RestrictionSyncfromFXtoSU',component:RestrictionSyncfxSuComponent},
    {path: 'ReservationSyncfromSUtoFX',component:ReservationSyncfxSuComponent},
    {path:'OHIPLog',component:OhipLogComponent},
    {path:'NewFNConfigInfo',component:NewfnconfiginfoComponent}, //Indhuja 20-11-2024
    {path:'NewFNDHSyncReport',component:NewfndhsyncreportComponent},//Indhuja 05-12-2024
    {path:'BookingsFromChannelstoFNNewPipe',component:BookingChFnNewpipeComponent}, //Indhuja 10-12-2024
    {path:'DalaLakeLog',component:DatalakelogComponent},//Indhuja 12-12-2024
    {path:'FXCRStoChannelInventoryFlowReport',component:FxcrstochinvflowreportComponent},//Indhuja 17-12-2024
    {path:'TICLog',component:TajInnerCircleComponent}, //Timali 23-12-2024
    {path:'FNtoChannelInventoryFlowReport',component:FntochinvflowreportComponent},//Indhuja 23-12-2024
    {path:'NewFNPipeActions',component:NewfnpipeactionsComponent},//Indhuja 28-01-205
    {path:'QatarLogData',component:QatarlogsnewComponent},//Indhuja 24-03-2025
    {path:'BingoForceLog',component:BingoForcelogComponent},//Indhuja 12-10-2025
    {path:'FXProcessLog',component:FxProccessLogComponent},//Indhuja 29-10-2025
        {path:'WSLog',component:WsLogComponent},//Indhuja 30-10-2025
    {path: 'DHProductSummaryDetails', 
      children: [{
        path: "",
        component: DhproductsummarydetailsComponent,
      },
      {
        path: "listdhproductsummarydetails",
        component: ListdhproductsummarydetailsComponent,
      }
  
      ]},//Indhuja 25-03-2025
      {path:'BookingsfromchanneltoFNPhaseII',component:BookingsChFNPhaseIIComponent},//Indhuja 11-09-2025
          {path:'NepalFNMIS',component:NepalFnmisComponent},//Indhuja 12.03.2026
          {path:'WhatsappLog',component:WhatsapplogComponent},//Indhuja 06.05.2026
          {path:'BookingsfromchanneltoFNPhaseII2026',component:BookingsChFnphaseiiNewtblComponent},//Indhuja 11-09-2025
          {path:'ChannelReservationSummary',component:ChannelreservationsummaryComponent},//Indhuja 17.07.2026
    // { path: '**', redirectTo: 'login' }
];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    CmtopmsbookingComponent,
    BookinglogComponent,
    InventorylogComponent,
    StrlogComponent,
    BtealogComponent,
    FxcrsinventoryComponent,
    FxcrsdownloadComponent,
    FxcrsuploadComponent,
    EdwComponent,
    OTAInsightsComponent,
    RestrictionsEnhancedComponent,
    SharedPipe,
    RateSyncFortuneComponent,
    RateSyncToChannelComponent,
    UnderConstructionComponent,
    BWPOSComponent,
    BWCRMComponent,
    QatarUploadComponent,
    GEMKOTDownloadComponent,
    RatepingUploadComponent,
    HotelTwoexeComponent,
    HotelOfflineComponent,
    HotelMultipleCmcrsComponent,
    GeneralcrmComponent,
    FxservicelogComponent,
    PulzelogComponent,
    RevnomixComponent,
    FxEInvoiceComponent,
    BytDisplayComponent,
    BbrDisplayComponent,
    FxgemUploadlogComponent,
    FxgemEmaillogComponent,
    FxgemPoslogComponent,
    FxgemPosapplogComponent,
    ViewhotelsbycmComponent,
    FxgemDoclogComponent,
    FxgemSettlementlogComponent,
    GuestprofileLogComponent,
    CompanyprofileLogComponent,
    GuestvisitrevenuesyncComponent,
    PosFromCrmdbComponent,
    FomFromCrmdbComponent,
    BillwisePmsdataComponent,
    GstrCleartaxComponent,
    InvTransactionComponent,
    OnlinePayrolljvComponent,
    OnlineSalesComponent,
    AcrCreditlimitComponent,
    OthersComponent,
    OnepagesummaryBygrpcodeComponent,
    ToBookingwhizzComponent,
    ToFxcrsComponent,
    GeneralcrmFxComponent,
    TrustuLogComponent,
    RedalertAuditComponent,
    UploadLogComponent,
    OnepageSummaryComponent,
    WbhidcoComponent,
    SabreinhouseLoyaltyComponent,
    DctkpiAbudhabiComponent,
    BitsilaLogComponent,
    TookanLogComponent,
    BonushubRazorpayComponent,
    InvFxcrsNewpipeComponent,
    RatePmsNewpipeComponent,
    HeartbeatLogsComponent,
    BookingFxcrstofnNewpipeComponent,
    BookingFntofxcrsNewpipeComponent,
    MappingDetailsComponent,
    FnDhnewpipeComponent,
    PropertysyncfxSUComponent,
    RoomtypesyncfxSuComponent,
    RateplansyncfxSuComponent,
    InventorysyncfxSuComponent,
    RateSyncfxSuComponent,
    RestrictionSyncfxSuComponent,
    ReservationSyncfxSuComponent,
    OhipLogComponent,
    NewfnconfiginfoComponent,
    NewfndhsyncreportComponent,
    BookingChFnNewpipeComponent,
    DatalakelogComponent,
    FxcrstochinvflowreportComponent,
    TajInnerCircleComponent,
    FntochinvflowreportComponent,
    OtaInsightsnewComponent,
    NewfnpipeactionsComponent,
    QatarlogsnewComponent,
    DhproductsummarydetailsComponent,
    ListdhproductsummarydetailsComponent,
    FomFromCrmdbNewComponent,
    FomFromCrmdbNewListComponent,
    BookingsChFNPhaseIIComponent,
    BingoForcelogComponent,
    FxProccessLogComponent,
    WsLogComponent,
    NepalFnmisComponent,
    WhatsapplogComponent,
    BookingsChFnphaseiiNewtblComponent,
    ChannelreservationsummaryComponent,
    FntochinvflowreportphaseIIComponent
  ],
  imports: [
    BrowserModule,AngularMultiSelectModule,MatSortModule, MatTableModule, MatPaginatorModule,MatProgressBarModule,MatCardModule,ToastrModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    BrowserAnimationsModule, MatInputModule,MatAutocompleteModule, ReactiveFormsModule, FormsModule, HttpClientModule,MatSelectModule,MatNativeDateModule,MatDatepickerModule,
    RouterModule.forRoot(AllRoutes),MatRadioModule,
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: 'danger' // set defaults here
    }),
    MatCheckboxModule,
    MatIconModule,
    // NgxMatSelectSearchModule,
    AngularFontAwesomeModule,
    // Md2Module,
    // CompatibilityModule,
    // NoConflictStyleCompatibilityMode,
    MatDatepickerModule,
    // AsyncPipe
  ],
  providers: [DatePipe,AsyncPipe],
  bootstrap: [AppComponent]
})
export class AppModule {
 }
